import React, { useState } from 'react';
import * as styles from './ControlBarInsightsUsersSelect.module.scss';
import useAppSelector from '../app/redux/useAppSelector';
import EntitySelect from '../search/entitySearch/EntitySelect';

interface ControlBarInsightsUsersSelectProps {
  autoFocus?: boolean;
  keepOpen?: boolean;
  filter?: (user: { id: string }, inputValue?: string) => boolean;
  placeholder?: string;
  onSelect?: (user: { id: string }) => void;
}

const ControlBarInsightsUsersSelect = ({
  autoFocus,
  keepOpen,
  filter,
  placeholder,
  onSelect,
}: ControlBarInsightsUsersSelectProps) => {
  const currentUser = useAppSelector((state) => state.session.user);

  const [inputValue, setInputValue] = useState('');
  const [isOpen, setIsOpen] = useState(autoFocus);

  const isMenuOpen = keepOpen || isOpen;

  return (
    <EntitySelect
      menuIsOpen={isMenuOpen}
      onMenuOpen={() => setIsOpen(true)}
      onMenuClose={() => setIsOpen(false)}
      value={null}
      autoFocus={autoFocus}
      config={{
        user: {
          sortBy: (u1, u2) => {
            // move the current user to the top
            if (u1.id === currentUser.id) return -1;
            if (u2.id === currentUser.id) return 1;

            return 0;
          },
          filter: filter ? (o) => filter(o, inputValue) : undefined,
        },
      }}
      disableMenuPortal
      placeholder={placeholder}
      containerClassName={styles.select}
      onChange={(result) => {
        if (result?.type !== 'user' || !onSelect) return;
        onSelect(result.user);
      }}
      inputValue={inputValue}
      onInputChange={setInputValue}
    />
  );
};

export default ControlBarInsightsUsersSelect;
